import { LocaleString } from "models/locale";
import { PrivacyPolicyModel } from "models/privacy-policy";
import { doGet, doPatch } from "services/request";

export const adminDoGetPrivacyPolicy = async () => {
  const privacyPolicy = await doGet<PrivacyPolicyModel>(
    "/admin/settings/privacy-policy",
  );
  return privacyPolicy;
};

export const adminDoPatchPrivacyPolicy = async (text: LocaleString) => {
  await doPatch("/admin/settings/privacy-policy", { text });
};
